import { defineMessages } from 'react-intl';

export default defineMessages({
  questionsFrequents: {
    id: 'dashboard_auto.questions_frequents',
  },
  allResponses: {
    id: 'dashboard_auto.all_responses',
  },
});
